import styled from "styled-components";

import EmailForm from "./common/EmailForm";

type Props = {
    codeOnline: string;
    returnBack: any;
    disabled?: boolean;
};

const SendPINCode = ({ codeOnline, returnBack, disabled }: Props) => {
    return (
        <EmailFormContainer>
            <EmailForm
                onlineCode={codeOnline}
                onSubmitSuccess={() => returnBack(null)}
                onSubmitFail={(error) => returnBack(error)}
                isPassword={false}
                disabled={disabled}
            />
        </EmailFormContainer>
    );
};

const EmailFormContainer = styled.div`
    padding: 1.5rem;
`;

export default SendPINCode;
